import { Theme as MuiTheme, createMuiTheme } from '@material-ui/core'

import { CSSProperties } from '@material-ui/styles'
import Color from 'color'

export const navBarHeight = 56
export const playerMobileHeight = (9 / 16) * 100 //Player is as wide as the whole viewport and has an aspect ratio of 16:9

const textDark = '#13161a'

const fonts = {
    notoSans: {
        regular: 'NotoSans',
        bold: 'NotoSansBold',
        light: 'NotoSansLight',
    },
    monserrat: {
        regular: 'Montserrat',
        light: 'MontserratLight',
        bold: 'MontserratBold',
        black: 'MontserratBlack',
    },
}

const cardVerticalPadding = '24px'
const cardHorizontalPadding = '20px'

export const themeObj = {
    breakpoints: {
        values: {
            xs: 0, // we stablish 0 for xs because it means 0px or larger
            sm: 414,
            md: 768,
            lg: 1024,
            xl: 1440,
            xxl: 1680,
        },
    },
    spacingPresets: {
        cardVerticalPadding,
        cardHorizontalPadding,
        cardPadding: `${cardVerticalPadding} ${cardHorizontalPadding}`,
    },
    gradients: {
        yellowToPink: `linear-gradient(-280deg, #ffc908 7%, #f73153)`,
    },
    colors: {
        brand: {
            pink: '#f73153',
            yellow: '#ffc908',
            blue: '#315cf7',
            green: '#50f29b',
            green2: '#1FE0C5',
        },
        light: {
            darkgrey: '#5e6675',
            grey: '#d3d5db',
            lightGray: '#f0f2f5',
            lightGray2: '#e2e2e2',
            lightGray3: '#E6E9F0',
            offWhite1: '#f7f9fc',
            offWhite2: '#faf7f7',
        },
        dark: {
            dark1: '#151a24',
            dark2: '#1c222e',
            dark3: '#1f2533',
            dark4: '#252d3d',
            dark5: '#15181f',
        },
        success: {
            default: '#4fbf96',
        },
        green: '#29e57c',
        black: '#0e1117',
        white: '#ffffff',
        orange: '#FA7F0F',
        red: '#CA2A2A',
        text: {
            dark: textDark,
            light: '#ffffff',
        },
        extraColors: {
            neutral: {
                White: '#FFFFFF',
                Neutral5: '#FAFCFF',
                Neutral10: '#EDF0F5',
                Neutral20: '#E6E9F0',
                Neutral40: '#D1D7E3',
                Neutral50: '#A2A9B8',
                Neutral55: '#CCD2E3',
                Neutral60: '#6D7585',
                Neutral65: '#424B5C',
                Neutral70: '#3B4252',
                Neutral75: '#313847',
                Neutral80: '#2A393D',
                Neutral85: '#232833',
                Neutral90: '#1C2029',
                Neutral95: '#15181F',
                Neutral100: '#0E1014',
                Black: '#000000',
            },
        },
    },
    fontColors: {
        dark: {
            color: textDark,
        },
        grey: {
            color: '#d3d5db',
        },
        darkGrey: {
            color: '#5e6675',
        },
        light: {
            color: '#ffffff',
        },
    },
    buttons: {
        primary: {
            height: '60px',
            borderRadius: '2px',
            backgroundColor: '#f73153',
        },
    },
    typographyPresets: {
        fonts,
        titleLargeBlack: {
            fontFamily: fonts.monserrat.black,
            fontSize: '48px',
            fontWeight: '900',
            lineHeight: '1.56',
            letterSpacing: '1.2px',
            color: textDark,
        },
        titleLargeBold: {
            fontFamily: fonts.monserrat.bold,
            fontSize: '48px',
            fontWeight: 'normal',
            lineHeight: '1.56',
            letterSpacing: '1.2px',
            color: textDark,
        },
        titleLarge: {
            fontFamily: fonts.monserrat.regular,
            fontSize: '48px',
            fontWeight: 'normal',
            lineHeight: '1.56',
            letterSpacing: '1.2px',
            color: textDark,
        },
        titleLargeLight: {
            fontFamily: fonts.monserrat.light,
            fontSize: '48px',
            fontWeight: 'normal',
            lineHeight: '1.56',
            letterSpacing: '1.2px',
            color: textDark,
        },
        titleMediumBlack: {
            fontFamily: fonts.monserrat.black,
            fontSize: '28px',
            fontWeight: 'normal',
            lineHeight: '1.29',
            color: textDark,
        },
        titleMediumBold: {
            fontFamily: fonts.monserrat.bold,
            fontSize: '28px',
            fontWeight: 'normal',
            lineHeight: '1.29',
            color: textDark,
        },
        titleMedium: {
            fontFamily: fonts.monserrat.regular,
            fontSize: '28px',
            fontWeight: 'normal',
            lineHeight: '1.29',
            color: textDark,
        },
        titleMediumLight: {
            fontFamily: fonts.monserrat.light,
            fontSize: '28px',
            fontWeight: 'normal',
            lineHeight: '1.29',
            color: textDark,
        },
        titleSmallBlack: {
            fontFamily: fonts.monserrat.black,
            fontSize: '16px',
            fontWeight: 'normal',
            lineHeight: '1.5',
            color: textDark,
        },
        titleSmallBold: {
            fontFamily: fonts.monserrat.bold,
            fontSize: '16px',
            fontWeight: 'normal',
            lineHeight: '1.5',
            color: textDark,
        },
        titleSmall: {
            fontFamily: fonts.monserrat.regular,
            fontSize: '16px',
            fontWeight: 'normal',
            lineHeight: '1.5',
            color: textDark,
        },
        titleSmallLight: {
            fontFamily: fonts.monserrat.light,
            fontSize: '16px',
            fontWeight: 'normal',
            lineHeight: '1.5',
            color: textDark,
        },
        artistName: {
            fontFamily: fonts.monserrat.black,
            fontSize: '24px',
            fontWeight: '900',
            lineHeight: '1.33',
            color: textDark,
        },
        subtitleLarge: {
            fontFamily: fonts.monserrat.regular,
            fontSize: '28px',
            lineHeight: '1.43',
            letterSpacing: '1.4px',
            color: textDark,
        },
        subtitleSmall: {
            fontFamily: fonts.monserrat.regular,
            fontSize: '16px',
            lineHeight: '1.25',
            color: textDark,
        },
        bodyPrimary: {
            fontFamily: fonts.notoSans.regular,
            fontSize: '16px',
            lineHeight: '1.75',
            color: textDark,
        },
        bodySecondary: {
            fontFamily: fonts.notoSans.regular,
            fontSize: '14px',
            lineHeight: '1.71',
            color: textDark,
            letterSpacing: 'normal',
        },
        bodyTertiary: {
            fontFamily: fonts.notoSans.regular,
            fontSize: '12px',
            lineHeight: '1.65',
            color: textDark,
        },
        bodyPrimaryBold: {
            fontFamily: fonts.notoSans.bold,
            fontSize: '16px',
            lineHeight: '1.75',
            color: textDark,
        },
        bodySecondaryBold: {
            fontFamily: fonts.notoSans.bold,
            fontSize: '14px',
            lineHeight: '1.71',
            color: textDark,
        },
        bodyTertiaryBold: {
            fontFamily: fonts.notoSans.bold,
            fontSize: '12px',
            lineHeight: '1.65',
            color: textDark,
        },
        bodyPrimaryLight: {
            fontFamily: fonts.notoSans.light,
            fontSize: '16px',
            lineHeight: '1.75',
            color: textDark,
        },
        bodySecondaryLight: {
            fontFamily: fonts.notoSans.light,
            fontSize: '14px',
            lineHeight: '1.71',
            color: textDark,
        },
        bodyTertiaryLight: {
            fontFamily: fonts.notoSans.light,
            fontSize: '12px',
            lineHeight: '1.65',
            color: textDark,
        },
        metaDataPrimary: {
            fontFamily: fonts.notoSans.regular,
            fontSize: '14px',
            fontWeight: 'bold',
            lineHeight: '2',
            color: '#5e6675',
        },
        labelPrimary: {
            fontFamily: fonts.notoSans.regular,
            fontSize: '12px',
            lineHeight: '1.5',
            color: '#000000',
            letterSpacing: 'normal',
        },
    },
    forms: {
        inline: {
            form: {
                display: 'flex',
                MsFlexFlow: 'row wrap',
                flexFlow: 'row wrap',
                MsFlexAlign: 'start',
                alignItems: 'start',
                justifyContent: 'flex-end',
                margin: '10px 0',
            },
            formCtrl: {
                flex: '1',
                margin: '0 !important',
                '& input': {
                    height: '40px',
                },
            },
        },
    },
    zIndexLevels: {
        zero: 0,
        one: 100,
        two: 200,
        three: 300,
        four: 400,
        five: 500,
        six: 600,
        seven: 700,
        eight: 800,
        nine: 900,
        ten: 1000,
    },
    modalClose: {
        right: '10px',
        top: '10px',
        position: 'absolute',
        cursor: 'pointer',
        display: 'flex',
        fontSize: '25px',
        opacity: 0.5,
        zIndex: 100,
    },
    utils: {
        convertHexToRGBA: (hex, opacity) =>
            Color(hex)
                .alpha(opacity)
                .rgb()
                .string(),
    },
    overrides: {
        MuiTooltip: {
            //TODO finish styling to add arrow
            tooltip: {
                backgroundColor: '#000000',
            },
        },
        MuiDialog: {
            paper: {
                margin: '0',
            },
        },
        MuiToolbar: {
            regular: {
                '@media (min-width: 0px)': {
                    minHeight: navBarHeight,
                },
            },
        },
    },
}

export const cadenzaBaseTheme = createMuiTheme(themeObj)

type ThemeObj = typeof themeObj

interface TypographyPresets {
    [k: string]: CSSProperties
    fonts: typeof fonts
}

interface ThemeExtension {
    spacingPresets: ThemeObj['spacingPresets']
    colors: ThemeObj['colors']
    fontColors: ThemeObj['fontColors']
    zIndexLevels: ThemeObj['zIndexLevels']
    gradients: ThemeObj['gradients']
    typographyPresets: TypographyPresets
    modalClose: CSSProperties
}

export type Theme = MuiTheme & ThemeExtension
